



































import { Component, Prop, Vue } from 'vue-property-decorator';
import ApiKey from '@/models/apiKey';
import {
  list as listApiKeys,
  create as createApiKey,
  remove as removeApiKey
} from '@/api/apiKeys';

@Component
export default class PlantView extends Vue {
  @Prop([Number, String]) readonly plantId!: number;
  keys: Array<string> = [];

  async mounted() {
    await this.fetch();
  }

  async fetch() {
    this.keys = (await listApiKeys(this.plantId)).map(x => x.key);
  }

  async add() {
    try {
      const newApiKey = await createApiKey(this.plantId);
      this.keys.push(newApiKey.key);
    } catch (e) {
      this.$toast.open({ message: e.message, type: 'is-danger' });
    }
  }

  async remove(key: string) {
    try {
      const newKey = await removeApiKey(key);
      this.keys = this.keys.filter(k => k !== key);
    } catch (e) {
      this.$toast.open({ message: e.message, type: 'is-danger' });
    }
  }

  copyToClipboard(key: string) {
    if (document === null) {
      this.$toast.open("Can't copy API Key. Please, copy it manually.");
      return;
    }
    const el = document.createElement('textarea'); // Create a <textarea> element
    el.value = key; // Set its value to the string that you want copied
    el.setAttribute('readonly', ''); // Make it readonly to be tamper-proof
    el.style.position = 'absolute';
    el.style.left = '-9999px'; // Move outside the screen to make it invisible
    document.body.appendChild(el); // Append the <textarea> element to the HTML document
    const selected =
      document.getSelection()!.rangeCount > 0 // Check if there is any content selected previously
        ? document.getSelection()!.getRangeAt(0) // Store selection if found
        : false; // Mark as false to know no selection existed before
    el.select(); // Select the <textarea> content
    document.execCommand('copy'); // Copy - only works as a result of a user action (e.g. click events)
    document.body.removeChild(el); // Remove the <textarea> element
    if (selected) {
      // If a selection existed before copying
      document.getSelection()!.removeAllRanges(); // Unselect everything on the HTML document
      document.getSelection()!.addRange(selected); // Restore the original selection
    }
    this.$toast.open('API Key copied.');
  }
}
